import { render, staticRenderFns } from "./tendencias.vue?vue&type=template&id=7c6d2bd4&scoped=true"
import script from "./tendencias.vue?vue&type=script&lang=js"
export * from "./tendencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d2bd4",
  null
  
)

export default component.exports